(function () {
  function initBestSellers(root) {
    const section = root.matches('.best-sellers') ? root : root.querySelector('.best-sellers');
    if (!section) return;

    const swiperEl = section.querySelector('.best-sellers__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    new Swiper(swiperEl, {
      slidesPerView: 1.2,
      spaceBetween: 22,
      speed: 500,
      grabCursor: true,
      breakpoints: {
        460: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: section.querySelector('.best-sellers__next'),
        prevEl: section.querySelector('.best-sellers__prev'),
      },
    });
  }

  function initAll() {
    document.querySelectorAll('.best-sellers').forEach(initBestSellers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initBestSellers(event.target);
  });
})();
